// pages/RepairPage.js

import Head from "next/head";
import { useCallback, useEffect, useState } from "react";
import AOS from "aos";
import GarageModal from "../../components/common/GarageModal";
import { isMobile } from "react-device-detect";
import { useRouter } from "next/router";
import Footer from "components/Footer/Footer";
import { usePlacesWidget } from "react-google-autocomplete";
import { GetInfo } from "lib/Location";
import { connect } from "react-redux";
import { getLocationData } from "redux/actions/globalAction";
import { getCoordinates } from "redux/actions/apiActions";
import { useForm } from "react-hook-form";
import API from "api";
import toast from "react-hot-toast";
import WorkshopMarketingFAQ from "components/workshop/WorkshopMarketingFAQ";
import {
  GoogleMap,
  useJsApiLoader,
  Marker,
  Autocomplete,
  LoadScript,
} from "@react-google-maps/api";
const GarageMarketing = ({ globalData, getCoordinates, getLocationData }) => {
  const [isVideoVisible, setVideoVisible] = useState(false);
  const [map, setMap] = useState(null);
  const [isPartnerModalOpen, setPartnerModalOpen] = useState(false);
  const [animationIndex, setAnimationIndex] = useState(1);
  const [showFullContent, setShowFullContent] = useState(false);
  const router = useRouter();
  const [lat, setLat] = useState(0);
  const [long, setLong] = useState(0);
  const [autocompleted, setAutocompleted] = useState();
  const [locationText, setLocationText] = useState("");
  const [loaded, setLoaded] = useState(false);
  const [skeletonLoading, setSkeletonLoading] = useState(false);
  const [dropDownSelection, setDropDownSelection] = useState(false);
  const [placeChanged, setPlaceChanged] = useState(null);
  const initialValue = {
    name: "",
    contactName: "",
    phoneNumber: "",
    email: "",
  };
  const [formData, setFormData] = useState(initialValue);
  const {
    register,
    handleSubmit,
    watch,
    reset,
    setValue,
    formState: { errors, isSubmitting },
    clearErrors,
  } = useForm();
  const { ref } = usePlacesWidget({
    apiKey: process.env.NEXT_PUBLIC_GOOGLE_MAP_KEY,
    onPlaceSelected: (place) => {
      setDropDownSelection(true);
      setLocationText(place.formatted_address);
      onPlaceChangedNew(
        place.geometry.location.lat(),
        place.geometry.location.lng(),
        place.formatted_address
      );
    },
    options: {
      types: [],
      componentRestrictions: { country: "AE" },
    },
  });
  const onLoad = useCallback(function callback(map) {
    const bounds = new window.google.maps.LatLngBounds({ lat: lat, lng: long });
    map.fitBounds(bounds);
    setMap(map);
  }, []);

  const getCurrentLocation = (isFirst = false) => {
    locateCurrentPosition()
      .then((position) => {
        const lat = Number(position.coords.latitude);
        const lang = Number(position.coords.longitude);
        setLat(Number(lat));
        setLong(Number(lang));
        if (isFirst && hadLocation) {
          const latCurrent = Number(hadLocation.lat);
          const langCurrent = Number(hadLocation.lang);
          getCoordinates(latCurrent, langCurrent, 10);
          setCheckCenter(false);
        } else {
          setLatTemp(Number(lat));
          setLongTemp(Number(lang));
        }

        onPlaceChangedNew(lat, lang);
      })
      .catch((e) => {
        // toast.error("Location not allowed")
        GetInfo(getinfoCallback, getinfoErrorCallback);
      });
  };
  const onLoading = (autocomplete) => {
    setAutocompleted(autocomplete);
  };

  const onPlaceSelected = (place) => {
    //   setDropDownSelection(true)
    setLocationText(place.formatted_address);
    onPlaceChangedNew(
      place.geometry.location.lat(),
      place.geometry.location.lng(),
      place.formatted_address
    );
  };
  useEffect(() => {
    if (placeChanged) {
      onPlaceSelected();
    }
  }, [placeChanged]);
  const getinfoCallback = (lat, lang) => {
    setLat(Number(lat));
    setLong(Number(lang));
    onPlaceChangedNew(lat, lang);
  };

  const getinfoErrorCallback = (lat, lng) => {
    setLoaded(false);
  };

  const onPlaceChangedNew = async (lats, longs) => {
    try {
      const lat = Number(lats);
      const lang = Number(longs);
      const size = 10;
      setLoaded(false);
      if (lat && lang) {
        await getLocationData(lat, lang, "");
        await getCoordinates(lat, lang, size);
        setLat(lat);
        setLong(lang);
      }
      setLoaded(true);
    } catch (error) {
      console.log(error);
      getCurrentLocation();
    }
  };

  const locateCurrentPosition = () =>
    new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          resolve(position);
        },
        (error) => {
          console.log(error.message);
          reject(error);
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 1000,
        }
      );
    });
  const onPlaceChanged = () => {
    if (autocompleted !== null) {
      try {
        setSkeletonLoading(true);
        setTimeout(() => {
          setSkeletonLoading(false);
        }, 2000);
        const lat = Number(autocompleted.getPlace()?.geometry?.location.lat());
        const lang = Number(autocompleted.getPlace()?.geometry?.location.lng());
        onPlaceChangedNew(lat, lang);
      } catch (error) {
        console.log(error);
        getCurrentLocation();
      }
    } else {
    }
  };
  useEffect(() => {

    if (globalData.locationData?.data) {
      setLocationText(globalData.locationData.data.EmirateArea);
      setLat(globalData.locationData.lat)
      setLong(globalData.locationData.lng)
    }
  }, [globalData.locationData?.data]);
  useEffect(() => {
    const intervalId = setInterval(() => {
      setAnimationIndex((prevIndex) => (prevIndex % 4) + 1);
    }, 5000);

    const handleScroll = () => {
      const scrollTop = window.scrollY;

      if (scrollTop > 600) {
        document.querySelector(".navbar").classList.add("navbar-fixed");
      } else {
        document.querySelector(".navbar").classList.remove("navbar-fixed");
      }
    };

    window.addEventListener("scroll", handleScroll);
    AOS.init();

    return () => {
      window.removeEventListener("scroll", handleScroll);
      clearInterval(intervalId);
    };
  }, []);

  const content = `Have you thought about elevating your car service and repairs business into the digital space
    to keep up with market demands? If you're looking to strengthen customer relations and
    increase your workshop's visibility in the UAE, Open Bonnet has the Solution! With a wide
    network of garages across the UAE, we guarantee business growth in your customer segment.
    Additionally, our advanced tools for customer relations and engagement practices make it
    easy for your workshop to succeed. Join Open Bonnet for a complete solution to enhance your
    workshop's success.`;

  const handleContactUsClick = () => {
    // Open the PartnerModal
    setPartnerModalOpen(true);
  };

  const handleCloseModal = () => {
    // Close the PartnerModal
    setPartnerModalOpen(false);
  };

  const toggleContent = () => {
    setShowFullContent(!showFullContent);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmitForm = async (data) => {

    const payload = {
      WorkshopName: data.WorkshopName,
      ContactPersonName: data.ContactName,
      PhoneNumber: data.PhoneNumber,
      Email: data.Email,
      LocationName: locationText,
      LocationLongitute: long,
      LocationLatitude: lat
    }
    console.log("Form Data: ", data);
    await API.post(`v2/api/workshop-request-leads`, payload, {
      headers: {
        // Authorization: "bearer " + token.access_token,
      },
    })
      .then(async (res) => {


        console.log(res);
        toast.dismiss();
        reset()
        toast.success("Form submitted successfully!");

      })
      .catch((err) => {

        console.log("Error ", err);
        toast.dismiss();
        toast.error("Something went wrong! Please retry.");
      });
  };
  return (
    <>
      <Head>
        <title>Open Bonnet | Partner-With-Us</title>
        <meta
          name="description"
          content="Partner With Us | Open Bonnet: Join the Widest Network of Garages across the UAE"
        />
      </Head>
      <div>
        <nav className="navbar navbar-expand-lg navbar-light custom-header-control">
          <a className="navbar-brand" href="/">
            <img src="/assets/garage/Logo12.webp" width={116} height={55} />
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* <div className="mobile-sl-btn">
            <span
              data-toggle="modal"
              data-target="#partnerModal"
              className="nav-link selling-btn"
              href="#"
            ></span>
          </div> */}

          <div
            className="collapse navbar-collapse grgtp-links"
            id="navbarSupportedContent"
          >
            <ul className="navbar-nav ml-auto">
              <li className="nav-item">
                <a className="nav-link" href="#">
                  <img src="/assets/garage/message.webp" width={20} height={16} />
                  <span>partner@openbonnet.com</span>
                </a>
              </li>

              <li className="nav-item">
                <a className="nav-link" href="#">
                  <img src="/assets/garage/call-in.webp" width={16} height={16} />
                  <span>+971 80 022 74357</span>
                </a>
              </li>

              <li className="nav-item mb-sl-none">
                <span
                  className="nav-link selling-btn"
                  onClick={handleContactUsClick}
                  style={{ cursor: "pointer" }}
                >
                  Start Selling
                </span>
              </li>
            </ul>
          </div>
        </nav>

        <section className="contact-section">
          <div className="container-fluid">
            <div className="row align-items-end">
              <div className="col-md-8">
                <div className="gr-contact-info">
                  <h2
                    className="white-txt grg-title"
                    style={{ color: "white" }}
                  >
                    Are You a Workshop Owner?
                  </h2>
                  <p style={{ color: "white" }}>
                    Be a part of UAE's widest car repair network with Open
                    Bonnet's Digital Platform. Grow your reach and start selling
                    your services to a wider audience Now!
                  </p>
                </div>
              </div>

              <div className="col-md-4">
                <form
                  className="gr-contact-form mobile-form-gr"
                  onSubmit={handleSubmit(handleSubmitForm)}
                >
                  <h4>Become an Open Bonnet Partner</h4>
                  <div className="mb-3">
                    <label htmlFor="name" className="form-label">
                      Workshop Name <span>*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("WorkshopName", { required: true })}
                      onKeyPress={(event) => {
                        if (/\d/.test(event.key)) {
                          // test if the pressed key is a number
                          event.preventDefault(); // prevent the input of numeric values
                        }
                      }}
                      onPaste={(event) => {
                        const clipboardData =
                          event.clipboardData || window.clipboardData;
                        const pastedData = clipboardData.getData("text");
                        if (/\d/.test(pastedData)) {
                          // test if the clipboard contents contain numeric values
                          event.preventDefault(); // prevent the paste operation
                        }
                      }}
                    />
                    {errors.WorkshopName && (
                      <span className="text-danger  w-100" style={{ fontSize: "12px" }}>
                        Workshop Name is required.
                      </span>
                    )}
                  </div>
                  <div className="mb-3">
                    <label htmlFor="contactName" className="form-label">
                      Contact Person Name <span>*</span>
                    </label>
                    <input
                      type="text"
                      name="ContactName"
                      className="form-control"
                      id="contactName"
                      {...register("ContactName", { required: true })}
                      onKeyPress={(event) => {
                        if (/\d/.test(event.key)) {
                          // test if the pressed key is a number
                          event.preventDefault(); // prevent the input of numeric values
                        }
                      }}
                      onPaste={(event) => {
                        const clipboardData =
                          event.clipboardData || window.clipboardData;
                        const pastedData = clipboardData.getData("text");
                        if (/\d/.test(pastedData)) {
                          // test if the clipboard contents contain numeric values
                          event.preventDefault(); // prevent the paste operation
                        }
                      }}
                    />
                    {errors.ContactName && (
                      <span className="text-danger   w-100" style={{ fontSize: "12px" }}>
                        Contact Person Name is required.
                      </span>
                    )}
                  </div>

                  <div className="mb-3">
                    <label htmlFor="phoneNumber" className="form-label">
                      Mobile Number <span>*</span>
                    </label>
                    <div className="mobile-num-input">
                      <span>
                        <i>
                          <img
                            src="/assets/garage/call-in.webp"
                            alt="Call Icon"
                          />
                        </i>
                        971
                      </span>
                      <input
                        type="text"

                        className="form-control"

                        onKeyDown={(e) => {
                          const isCtrlKey = e.ctrlKey || e.metaKey; // Check if "ctrl" or "cmd" key is pressed
                          const keyValue = e.key;
                          const numericRegex = /^[0-9]*$/;
                          if (
                            !(
                              numericRegex.test(keyValue) ||
                              isCtrlKey ||
                              keyValue === "Backspace"
                            )
                          ) {
                            e.preventDefault();
                          }
                        }}
                        onPaste={(e) => {
                          const pastedValue = e.clipboardData.getData("text");
                          const numericRegex = /^[0-9]*$/;
                          if (!numericRegex.test(pastedValue)) {
                            e.preventDefault();
                          }
                        }}
                        onInput={(e) => {
                          if (e.target.value.length > e.target.maxLength)
                            e.target.value = e.target.value.slice(
                              0,
                              e.target.maxLength
                            );
                        }}
                        maxLength={9}
                        {...register("PhoneNumber", {
                          required: true,
                          validate: (value) => value[0] === "5" &&
                            (value[1] === "5" ||
                              value[1] === "2" ||
                              value[1] === "0" ||
                              value[1] === "6" ||
                              value[1] === "4" ||
                              value[1] === "8")
                            && value.length === 9,
                        })}
                      />

                    </div>
                    {errors.PhoneNumber && (
                      <span className="text-danger   w-100" style={{ fontSize: "12px" }}>
                        Enter valid mobile number.
                      </span>
                    )}
                  </div>

                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">
                      Email Address <span>*</span>
                    </label>
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      id="email"
                      {...register("Email", {
                        required: true,
                        pattern: {
                          value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                          message: "invalid email address",
                        },
                      })}
                    />
                    {errors.Email && (
                      <span className="text-danger   w-100" style={{ fontSize: "12px" }}>
                        Email Address is required & valid
                      </span>
                    )}
                  </div>

                  <div className="mb-3">
                    <label htmlFor="workshop" className="form-label">
                      Location <span>*</span>
                    </label>
                    <div className="gps-location">
                      <span>
                        <i onClick={getCurrentLocation}>
                          <img src="/assets/garage/gps.webp" alt="GPS Icon" />
                        </i>
                      </span>
                      {autocompleted ? (
                        <Autocomplete
                          onLoad={onLoading}
                          onPlaceChanged={onPlaceChanged}
                          types={"geocode"}
                          restrictions={{ country: ["AE"] }}
                        >
                          <input
                            type="text"
                            id="workshop"
                            placeholder="Search Location"
                            className="form-control ssssss"
                            ref={ref}
                            value={locationText}
                            onChange={(e) => setLocationText(e.target.value)}
                          />
                        </Autocomplete>
                      ) : (
                        <input
                          type="text"
                          id="workshop"
                          placeholder="Search Location"
                          className="form-control oooooo"
                          ref={ref}
                          value={locationText}
                          onChange={(e) => setLocationText(e.target.value)}
                        />
                      )}
                    </div>
                  </div>

                  <div className="submit-btn-contrl mt-0">
                    <button
                      type="submit"
                      className="btn btn-orange-sbtn submit-btn pt-0"
                      disabled={isSubmitting}
                    >
                      Submit

                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>

        <section className="abt-txt-grg">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="abt-mrk-section">
                  {isMobile ? (
                    <>
                      {showFullContent ? (
                        content
                      ) : (
                        <>
                          {content.split("\n").slice(0, 1).join("\n")}
                          <button
                            onClick={toggleContent}
                            className="req-an-btn-view"
                          >
                            View more
                          </button>
                        </>
                      )}
                    </>
                  ) : (
                    content
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="abt-platform-grg">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="grg-head-block">
                  <h2>Online Platform Reach = Substantial Gains</h2>
                </div>
              </div>

              <div className="col-md-4">
                <div className="platform-grg-element">
                  <h2>
                    <span>+</span>25%
                  </h2>
                  <h3>Average Increase in Avg. Order Value</h3>
                  <p>
                    Open Bonnet provides you with diverse viewership and
                    audience exposure, enabling you to showcase a variety of
                    jobs and automotive services that you offer.
                  </p>
                </div>
              </div>

              <div className="col-md-4">
                <div className="platform-grg-element">
                  <h2>
                    <span>+</span>40%
                  </h2>
                  <h3>Average Increase in Conversion Rates</h3>
                  <p>
                    Promote personalized workshop offers on Open Bonnet’s
                    platform to reach your target audience. Elevate satisfaction
                    with our interest-free instalments for an enhanced customer
                    experience.
                  </p>
                </div>
              </div>

              <div className="col-md-4">
                <div className="platform-grg-element">
                  <h2>
                    <span>+</span>48%
                  </h2>
                  <h3>Repeat Customer Purchase Rate</h3>
                  <p>
                    Our digital platform offers compelling incentives such as
                    Cash Points, OB Service History, and a robust CRM engine to
                    foster long-term customer retention at your automotive
                    service center.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="partnership-grg-section">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="grg-head-block text-center">
                  <h2>Partnership Offerings</h2>
                </div>
              </div>
            </div>
            <div className="row cst-offring-block">
              <div className="col-md-12">
                <div className="mobscrl-bar">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="elem-bordered">
                        <div className="tp-bar-elm">
                          <span>
                            <img src="/assets/garage/eye.webp" width={39} height={27} />
                          </span>
                          <h3>Increased Visibility</h3>
                        </div>
                        <p>
                          Open Bonnet enhances your workshop's online
                          visibility, making it easier for potential customers
                          to find you.
                        </p>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="elem-bordered">
                        <div className="tp-bar-elm">
                          <span>
                            <img src="/assets/garage/Digitize_services.webp" width={42} height={31} />
                          </span>
                          <h3>Digitize your services</h3>
                        </div>
                        <p>
                          Open Bonnet offers advanced tools for seamless
                          appointment scheduling, inventory management, and
                          customer communication, streamlining your workshop
                          operations
                        </p>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="elem-bordered">
                        <div className="tp-bar-elm">
                          <span>
                            <img src="/assets/garage/RunRobust.webp" width={35} height={36} />
                          </span>
                          <h3>Run Robust Marketing Campaigns</h3>
                        </div>
                        <p>
                          Open Bonnet provides cost-effective marketing
                          solutions, reducing the need for workshops to invest
                          heavily in advertising and promotion.
                        </p>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="elem-bordered">
                        <div className="tp-bar-elm">
                          <span>
                            <img src="/assets/garage/Data-Driven.webp" width={28} height={28} />
                          </span>
                          <h3>Data-Driven Insights</h3>
                        </div>
                        <p>
                          With Open Bonnet your workshop benefits in best
                          serving & retaining users as we use valuable data
                          insights and analytics to understand customer
                          behaviours and preferences.
                        </p>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="elem-bordered">
                        <div className="tp-bar-elm">
                          <span>
                            <img src="/assets/garage/Discounts.webp" width={34} height={36} />
                          </span>
                          <h3>Exclusive Promotions and Discounts</h3>
                        </div>
                        <p>
                          You can promote special discounts and promotions
                          available exclusively to your workshop for Open Bonnet
                          customers, driving customer loyalty and repeat
                          business.
                        </p>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="elem-bordered">
                        <div className="tp-bar-elm">
                          <span>
                            <img src="/assets/garage/like.webp" width={38} height={36} />
                          </span>
                          <h3>Customer Feedback and Ratings</h3>
                        </div>
                        <p>
                          Showcase positive customer feedback and high ratings
                          received by your workshop on Open Bonnet, indicating
                          their excellent service quality.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="row justify-content-center">
                    <div className="col-md-4">
                      <div className="elem-bordered">
                        <div className="tp-bar-elm">
                          <span>
                            <img src="/assets/garage/pay.webp" width={47} height={38} />
                          </span>
                          <h3>Flexible Payment Options</h3>
                        </div>
                        <p>
                          Open Bonnet offers a wide range of payment options for
                          the services you provide from instant online
                          transactions to interest free instalment payment
                          options.
                        </p>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="elem-bordered">
                        <div className="tp-bar-elm">
                          <span>
                            <img src="/assets/garage/package.webp" width={39} height={39} />
                          </span>
                          <h3>
                            Sell Annual or One-time Service & Maintenance
                            Packages
                          </h3>
                        </div>
                        <p>
                          Open Bonnet offers garage partners to showcase their
                          annual service packages for customers to conduct a
                          periodic service maintenance to ensure vehicle
                          longevity.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* <section className="stories-section">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="grg-head-block text-center text-white">
                                    <h2 style={{ color: "white" }}>
                                        Success Stories
                                    </h2>
                                </div>

                            </div>

                        </div>

                        <div className="row sl-row">
                            <div className="col-md-6 border-right-mrk">
                                <div className="vdeo-blok ">
                                    <div className="vdeo-top-block">
                                        <div id="image-layer" style={{ display: isVideoVisible ? 'none' : 'block' }} className="image-layer-about" onClick={handleImageLayerClick}>
                                            <div id="playButton"></div>
                                        </div>

                                        {isVideoVisible && (
                                            <div className="video-elm-div" style={{ display: isVideoVisible ? 'block' : 'none' }}>
                                                <div id="pauseButton"></div>
                                                <video id="video" className="video-elm" style={{ display: isVideoVisible ? 'block' : 'none' }} src="/assets/garage/pexels_videos.mp4" autoPlay controls></video>
                                            </div>
                                        )}
                                    </div>

                                    <div className="vdeo-bottom-block">
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s</p>

                                        <div className="test-cl-img">
                                            <span>
                                                <img src="/assets/garage/user.png" />
                                            </span>
                                            <label>
                                                <span>Sakher Al-Amir </span>
                                                <strong>New Expert Excellent Auto</strong>
                                            </label>
                                        </div>
                                    </div>

                                </div>
                            </div>



                            <div className="col-md-6">
                                <div className="vdeo-blok">
                                    <div className="vdeo-top-block">
                                        <div id="image-layer" className="image-layer-about second-vdeo-image">
                                            <div id="playButton"></div>
                                        </div>

                                        <video id="video" className="video-elm" src="/assets/garage/pexels_videos.mp4"></video>
                                    </div>

                                    <div className="vdeo-bottom-block">
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s</p>

                                        <div className="test-cl-img">
                                            <span>
                                                <img src="/assets/garage/user.png" />
                                            </span>
                                            <label>
                                                <span>Sakher Al-Amir </span>
                                                <strong>New Expert Excellent Auto</strong>
                                            </label>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div>

                        </div>
                    </div>
                </section> */}

        <section className="signup--gr-block">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="grg-head-block">
                  <h2>What you get on Sign-Up</h2>
                </div>
              </div>
              <div className="col-md-6 order-md-1 order-sm-2 order-2">
                <div className="grg-sgp-list">
                  <ul className="grg-spg-ul">
                    <li>
                      <span className={animationIndex === 1 ? "dOeUIS" : ""}>
                        1
                      </span>
                      <h3 className={animationIndex === 1 ? "fODnTg" : ""}>
                        Robust Order Management Platform optimized for web.
                      </h3>
                    </li>

                    <li>
                      <span className={animationIndex === 2 ? "dOeUIS" : ""}>
                        2
                      </span>
                      <h3 className={animationIndex === 2 ? "fODnTg" : ""}>
                        Free Workshop Listing & Storefront Activation
                      </h3>
                    </li>

                    <li>
                      <span className={animationIndex === 3 ? "dOeUIS" : ""}>
                        3
                      </span>
                      <h3 className={animationIndex === 3 ? "fODnTg" : ""}>
                        Platform Usable Across Tablet & Mobile
                      </h3>
                    </li>

                    <li>
                      <span className={animationIndex === 4 ? "dOeUIS" : ""}>
                        4
                      </span>
                      <h3 className={animationIndex === 4 ? "fODnTg" : ""}>
                        Training to Improve Workshop Quality Control & Customer
                        Experience
                      </h3>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-md-6 order-md-2 order-sm-1 order-1">
                <div className="slider-block-spn">
                  <div className="slider-block-spn-tp">
                    {animationIndex === 1 && (
                      <img
                        style={{ paddingTop: "30px" }}
                        src="/assets/garage/one.webp"
                        alt="Image 1"
                      />
                    )}
                    {animationIndex === 2 && (
                      <img
                        style={{ paddingTop: "30px" }}
                        src="/assets/garage/two.webp"
                        alt="Image 2"
                      />
                    )}
                    {animationIndex === 3 && (
                      <img
                        style={{ paddingTop: "30px" }}
                        src="/assets/garage/three.webp"
                        alt="Image 3"
                      />
                    )}
                    {animationIndex === 4 && (
                      <img
                        style={{ paddingTop: "30px" }}
                        src="/assets/garage/four.webp"
                        alt="Image 4"
                      />
                    )}
                  </div>

                  <div className="slider-block-spn-bl">
                    <img src="/assets/garage/sp-shape.webp" />
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="query-action">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleContactUsClick}
                  >
                    <span>Have queries?</span>
                    <label>Contact Us</label>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="map-block">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="grg-head-block text-center mnbtm">
                  <h2>Checkout Our Partner Garages from all across UAE</h2>
                </div>
              </div>

              <div className="col-md-12">
                <div className="map-element">
                  <img className="dsk-map" src="/assets/garage/map.webp" />
                  <img className="mob-map" src="/assets/garage/map.webp" />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="vist-str">
                  <button
                    className="vst-str-btn"
                    onClick={() => router.push("/workshop-network")}
                  >
                    <span>View OB Network</span>
                    <img src="/assets/garage/arrow-right.webp" width={16} height={11} />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* <footer className="main-footer" >
                    <div className="ftlogo-bar">
                        <img src="/assets/home/logo-ft.webp" style={{
                            verticalAlign: "middle",
                            borderStyle: "none"
                        }} />
                    </div>

                    <div className="footer-top">


                        <div className="container" >
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="ft-fs-block">
                                        <h4 className="ft-header">Open Bonnet</h4>
                                        <p style={{ marginTop: "0px", marginBottom: "1rem", color: "black", fontSize: "16px" }}>
                                            Open Bonnet is a Marketplace Where Car Owners Are Connected With Verified Service Providers Through A Fully Digitized Experience Offering Convenience, Quality & Trust!
                                        </p>
                                        <ul className="style-ul contact-info-light">
                                            <li><a href="tel:+9718002274357"><i className="fa-solid fa-phone"></i> <span>+9718002274357</span></a></li>
                                            <li><a  href="https://api.whatsapp.com/send?phone=9718002274357" target="_blank"><i className="fa-brands fa-whatsapp"></i><span>WhatsApp us</span></a></li>
                                            <li><a href="mailto:user@openbonnet.com"><i className="fa-solid fa-envelope"></i><span>user@openbonnet.com</span></a></li>
                                        </ul>

                                        <div className="widget">
                                            <ul className="style-ul social-icons-ft" style={{
                                                display: 'flex',
                                                padding: '20px 0px'
                                            }}>
                                                <li><a href="https://www.facebook.com/openbonnetdotcom/"><i className="fa-brands fa-square-facebook"></i></a></li>
                                                <li><a href="https://www.instagram.com/open_bonnet/"><i className="fa-brands fa-square-instagram"></i></a></li>
                                                <li><a href=""><i className="fa-brands fa-square-x-twitter"></i></a></li>
                                                <li><a href=""><i className="fa-brands fa-linkedin"></i></a></li>
                                                <li><a href=""><i className="fa-brands fa-youtube"></i></a></li>
                                                <li><a href=""><i className="fa-brands fa-tiktok"></i></a></li>
                                                <li><a href=""><i className="fa-brands fa-square-snapchat"></i></a></li>

                                            </ul>
                                        </div>
                                        <div className="widget">
                                            <ul className="footer-payment style-ul">
                                                <li className="pr-2"><a href="#"><img src="/assets/footer/visa.svg" alt="visa" /></a></li>
                                                <li className="pr-2"><a href="#"><img src="/assets/footer/mastercard.webp" style={{ width: "60px" }} alt="master_card" /></a></li>
                                                <li className="pr-2"><a href="#"><img src="/assets/footer/payit.svg" alt="payit" /></a></li>
                                            </ul>
                                        </div>

                                    </div>
                                </div>

                                <div className="col-md-3">
                                    <div className="">
                                        <h4 className="ft-header">Links</h4>
                                        <ul className="widget-links footer-links-bl style-ul">
                                            <li><a className="foot-text" href="/about-us">About Us</a></li>
                                            <li><a className="foot-text" href="/faq">FAQs</a></li>
                                            <li><a className="foot-text" href="/">For Service Providers</a></li>
                                            <li><a className="foot-text" href="/">Service Date Calculator</a></li>
                                            <li><a className="foot-text" href="/blog/grid-standard-right-sidebar">Blogs</a></li>
                                            <li><a className="foot-text" href="/">Tools &amp; Calculators</a></li>
                                            <li><a className="foot-text" href="/privacy-policy">Privacy Policy</a></li>
                                            <li><a className="foot-text" href="/terms-and-conditions">Service Terms</a></li>
                                            <li><a className="foot-text" href="/fleet-service">Fleet Servicing Solution</a></li>
                                            <li><a className="foot-text" href="/super-car">Supercar Services</a></li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="col-md-3">

                                    <div className="">
                                        <h4 className="ft-header">Services</h4>
                                        <ul className="widget-links style-ul footer-links-bl">
                                            <li><a className="foot-text" href="/services/fujairah/oil-change">Oil Change Periodic Services</a></li>
                                            <li><a className="foot-text" href="/services/fujairah/repair">Maintenance &amp; Repair</a></li>
                                            <li><a className="foot-text" href="/services/fujairah/car-care">Car Care &amp; Cleaning</a></li>
                                            <li><a className="foot-text" href="/services/fujairah/tires-wheels">Tyres &amp; Wheels</a></li>
                                            <li><a className="foot-text" href="/services/fujairah/battery">Battery Assistance</a></li>
                                            <li><a className="foot-text" href="/services/fujairah/inspection">Pre-Purchase Inspection</a></li>
                                            <li><a className="foot-text" href="/services/fujairah/ac-service">Air Conditioning Services</a></li>
                                            <li><a className="foot-text" href="/services/fujairah/mobile-mechanic">At-Home Services</a></li>
                                            <li><a className="foot-text" href="/services/fujairah/breakdown">Car Breakdown</a></li>
                                            <li><a className="foot-text" href="/services/fujairah/car-wash-at-home">Car Wash at Home</a></li>
                                            <li><a className="foot-text" href="/services/fujairah/service-contract">Service Contract</a></li>
                                        </ul>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="whatsapp-container">
                                    <div className="row">
                                        <div className="col-md-7" >
                                            <div className="whatsapp-left">
                                                <div className="whatsapp-icon">
                                                    <img src="/assets/whatsapp_new.svg" />
                                                </div>
                                                <div className="whatsapp-txt">
                                                    <h5>Subscribe to our WhatsApp Channel</h5>
                                                    <span>Stay connected with OB & get alerts of best offers for your car.</span>
                                                </div>
                                            </div>


                                        </div>


                                        <div className="col-md-5">
                                            <div className="whatsapp-right" style={{ display: "flex" }}>
                                                <div className="mob-num">
                                                    <img className="img-fluid" src="/assets/header/uae-flag.svg" style={{ width: "25px" }} />
                                                    <span>+971</span>
                                                    <input type="text" className="form-control" placeholder="Phone Number" />
                                                </div>

                                                <div className="wp-sb">
                                                    <button className="btn cm-orange-btn">Subscribe</button>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="imp-footer">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-6">
                                    <p className="mb-3 mb-md-0 text-left greyC">Using this website you agree to our <a href="/terms-and-conditions">terms &amp; conditions</a> and <a href="/privacy-policy">privacy policy</a>.</p>
                                </div>
                                <div className="col-md-6">
                                    <p className="mb-3 mb-md-0 text-right greyC">© 2022 - 2023 All rights reserved by <a href="https://www.openbonnet.com" className="blueC" target="_blank">OpenBonnet</a></p>
                                </div>

                            </div>
                        </div>

                    </div>

                </footer>

                <div className="modal fade" id="partnerModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-body">

                            <form className="gr-contact-form modal-content " action="">
                                <div className="modal-close-button ">
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <h4>Become an Open Bonnet  Partner</h4>
                                <div className="mb-3">
                                    <label for="name" className="form-label">Workshop Name <span>*</span></label>
                                    <input type="text" className="form-control" id="name" />
                                </div>
                                <div className="mb-3">
                                    <label for="email" className="form-label">Contact Person Name <span>*</span></label>
                                    <input type="text" className="form-control" id="email" />
                                </div>

                                <div className="mb-3">
                                    <label for="email" className="form-label">Mobile Number <span>*</span></label>
                                    <div className="mobile-num-input">
                                        <span><i><img src="/assets/garage/call-in.svg" /></i>971</span>
                                        <input type="text" className="form-control" id="email" />
                                    </div>


                                </div>

                                <div className="mb-3">
                                    <label for="email" className="form-label">Email Address <span>*</span></label>
                                    <input type="email" className="form-control" id="email" />
                                </div>


                                <div className="mb-3">
                                    <label for="email" className="form-label">Location <span>*</span></label>
                                    <div className="gps-location">
                                        <span><i><img src="/assets/garage/gps.svg" /></i></span>
                                        <input type="text" className="form-control" id="email" />
                                    </div>

                                </div>


                                <div className="submit-btn-contrl">
                                    <button type="submit" className="btn btn-orange-sbtn">Submit</button>
                                </div>
                            </form>

                        </div>
                    </div>
                </div> */}
        <WorkshopMarketingFAQ />
        <Footer />

        <GarageModal isOpen={isPartnerModalOpen} onClose={handleCloseModal} handleSubmitForm={handleSubmitForm} globalData={globalData} />
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    apiData: state.apiData,
    globalData: state.globalData,
    cart: state.cart,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getCoordinates: (lat, lang, size) => {
      dispatch(getCoordinates(lat, lang, size));
    },
    getLocationData: (lat, lng, address) => {
      dispatch(getLocationData(lat, lng, address));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GarageMarketing);
